
'use strict';

var cart = require('base/cart/cart');

var updateMiniCart = true;
var popoverTimeout;

const isRangritiSite = document.querySelector('[data-siteid="Rangriti"]') !== null;
const bibaMiniCart = document.querySelector('.biba-minicart');

module.exports = function () {

    if (!isRangritiSite) {
        bibaMiniCart?.addEventListener('click', openBibaMinicart);
        initBibaClickEvent();       
    } else {
        $('.minicart').on('mouseenter focusin touchstart' , function () {
            if ($('.search:visible').length === 0) {
                return;
            }
            var url = $('.minicart').data('action-url');
            var count = parseInt($('.minicart .minicart-quantity').text(), 10);

                if (!updateMiniCart) {
                    $('.minicart .popover').addClass('show');
                    refreshMinicartRecommendation();
                    addEllipsis(2);
                    return;
                }

                addEllipsis(2);

                $('.minicart .popover').addClass('show');
                $('.minicart .popover').spinner().start();
                $.get(url, function (data) {
                    $('.minicart .popover').empty();
                    $('.minicart .popover').append(data);
                    updateMiniCart = false;
                    $.spinner().stop();
                });
        });
    }


    $('body').on('product:afterAddToCart', function (event, data) {
        updateMiniCart = true;

        if (!isRangritiSite) {
            $('.minicart-quantity').text(data.cart.numItems);          
        } else {
            $('.minicart').trigger('mouseenter');

            $('.minicart, .minicart .popover').on('mouseenter', function () {
                if (popoverTimeout) {
                    clearTimeout(popoverTimeout);
                }
            });

            popoverTimeout = setTimeout(function () {
                $('.minicart .popover').removeClass('show');
                popoverTimeout = null;
            }, 2000);

            $('.minicart .popover').on('mouseleave', function () {
                if (popoverTimeout) {
                    clearTimeout(popoverTimeout);
                }

                popoverTimeout = setTimeout(function () {
                    $('.minicart .popover').removeClass('show');
                    popoverTimeout = null;
                }, 2000);
            });
        }        
    });

};


function closeBibaMinicart(event) {
    event.preventDefault();
    event.stopImmediatePropagation();

    showFaq(true);

    document.body.classList.remove('no-scroll');
    $('.biba-minicart .popover').removeClass('show');
    bibaMiniCart?.classList.remove('biba-minicart-open');
    bibaMiniCart?.addEventListener('click', openBibaMinicart);
}
function openBibaMinicart(event) {
    event.preventDefault();
    event.stopImmediatePropagation();

    showFaq(false);

    bibaMiniCart?.removeEventListener('click', openBibaMinicart);

    document.body.classList.add('no-scroll');
    bibaMiniCart?.classList.add('biba-minicart-open');

    if ($('.search:visible').length === 0) {
        return;
    }
    var url = $('.biba-minicart').data('action-url');
    var count = parseInt($('.biba-minicart .minicart-quantity').text(), 10);

    const miniCartScroller = document.querySelector('.biba-minicart .minicart-scroller'); 
    
    

    if (!updateMiniCart) {
        $('.biba-minicart .popover').addClass('show');
        refreshMinicartRecommendation();
        addEllipsis(2);
        if (miniCartScroller) {
            miniCartScroller.scrollTop = 0;
        }
        return;
    }

    addEllipsis(2);

    $('.biba-minicart .popover').addClass('show');
    $('.biba-minicart .popover').spinner().start();
    $.get(url, function (data) {
        $('.biba-minicart .popover').empty();
        $('.biba-minicart .popover').append(data);
        updateMiniCart = false;
        $.spinner().stop();
    });

    if (miniCartScroller) {
        miniCartScroller.scrollTop = 0;
    }
}        

function addEllipsis(lineNumber) {
    document.querySelectorAll('.minicart-cross-sell-recommendation__products .pdp-link .link').forEach(el => {
        const lineHeight = parseFloat(getComputedStyle(el).lineHeight);
        const maxLines = lineNumber;
        const maxHeight = lineHeight * maxLines;

        if (el.scrollHeight > maxHeight) {
            let text = el.textContent.trim();

            while (el.scrollHeight > maxHeight && text.length > 0) {
            text = text.slice(0, -1);
            el.textContent = text + '…';
            }
        }
    });
}

function refreshMinicartRecommendation() {
    var $slider = $('.minicart-cross-sell-recommendation__products').find('.slick-slider'),
        $sliderLength = $slider .length > 0;

    if ($sliderLength) {
        $slider.slick('refresh').slick('setPosition');
    }
}

function initBibaClickEvent() {
    
    document.addEventListener('click', (e) => {
        const isMinicartOpen = document.querySelector('.biba-minicart')?.classList.contains('biba-minicart-open'), 
            bibaMiniCartCloseBtn = e.target.closest('.biba-minicart__close-btn') || e.target.closest('.biba-minicart__close-btn-icon'),
            bibaMiniCartBg = e.target.closest('.biba-minicart__placeholder-bg'),            
            removeProductModal = e.target.closest('#removeProductModal');

        if (isMinicartOpen) {
            bibaMiniCartCloseBtn && closeBibaMinicart(e);
            bibaMiniCartBg  && closeBibaMinicart(e);
            removeProductModal &&  closeBibaMinicart(e);    
        }
        
    });
}

function showFaq(status) {
    const faq = document.querySelector('.faq-parent-container');

    if (status) {
        faq?.classList.remove('hidden');
    } else {
        faq?.classList.add('hidden');
    }

}